// extracted by mini-css-extract-plugin
export default {"templateEditor":"TemplateEditor_templateEditor__UD6Dv","canvasBox":"TemplateEditor_canvasBox__XqPWt","loadingText":"TemplateEditor_loadingText__ITZTn"};